import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import { DropdownMenuPosition } from 'ui-components/components/INTERNAL/dropdown/dropdown-menu-position';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from './messages';
import style from './single-fulfillment-plan-orders-grid-sidebar-drawer-header.module.less';
import { emptyArray } from 'ui-components/default-props/empty';
import Global from '../../../store/global-selectors';
import OrdersDrawerAddToBatchDropdownContainer from '../../add-to-batch-dropdown/orders-drawer-add-to-batch-dropdown.container';
import DataDrivenLogo from '../../data-driven-logo';
import { OrdersGridPrintDocumentButton } from '../../orders-grid/print-document-button';

const salesOrderInfoSelector = createSelector(
  (state, salesOrderIds) => Global.selectEntitiesSalesOrdersByIds(state, { salesOrderIds }) || emptyArray,
  (salesOrders) => {
    const orderNumbers = salesOrders.map((salesOrder) => salesOrder?.orderNumber).join(', ');
    const marketplaceId = salesOrders[0]?.store?.marketplaceId ?? null;
    const externalUrl = salesOrders[0]?.store?.externalUrl ?? '';

    return {
      orderNumbers,
      marketplaceId,
      externalUrl,
    };
  },
);

/**
 * @param {object} props
 * @param {string[]} props.salesOrderIds
 * @returns {JSX.Element}
 */
export const SingleFulfillmentPlanOrdersGridSidebarDrawerHeader = ({ salesOrderIds }) => {
  const { orderNumbers, marketplaceId, externalUrl } = useSelector((state) => salesOrderInfoSelector(state, salesOrderIds));

  const isSilentlyLoading = useSelector((state) => Global.selectEntitiesSalesOrderIsLoading(state, { salesOrderId: salesOrderIds[0] }));

  const title = <Text shouldTruncate textType={TextType.H3} value={orderNumbers} />;

  return (
    <div className={style['single-fulfillment-plan-header']}>
      <div className={style['header-content-container']}>
        {marketplaceId ? (
          <DataDrivenLogo className={style['marketplace-logo']} logoType='icon' marketplaceId={Number.parseInt(marketplaceId, 10)} />
        ) : null}
        {externalUrl ? (
          <a className={style['order-number-link']} href={externalUrl} rel='noopener noreferrer' target='_blank'>
            {title}
          </a>
        ) : (
          title
        )}
        {isSilentlyLoading ? (
          <div className={style['loading-indicator-wrapper']}>
            <LoadingIndicator className={style['loading-indicator']} />
            <Text textType={TextType.Caption} value={messages.loading} />
          </div>
        ) : null}
      </div>
      <div className={style['actions-container']}>
        <OrdersDrawerAddToBatchDropdownContainer
          dropdownTogglerClassname={style['header-dropdown']}
          menuPosition={DropdownMenuPosition.BottomRight}
        />
        <OrdersGridPrintDocumentButton dropdownTogglerClassname={style['header-dropdown']} theme='link' unstyled />
      </div>
    </div>
  );
};
